import { useLocation } from 'react-router-dom';

// Exports
// -------

export default function useReturnToPath() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search || location.state?.from?.search);
  const returnToParam = searchParams.get('return_to');

  if (!returnToParam) {
    return;
  }

  return decodeURIComponent(returnToParam);
}
